export default {
  data() {
    return {
      couponFocus: {},
      couponFocusIndex: '',
      couponFocusIndex0: '',
      couponFocusKey: '',

      selectedPayWay: '',
    }
  },
  methods: {
    focusCouponInput_mixin(item, index, index0) {
      console.log(`%c选择的优惠券数据+索引:`, 'color: #f00;', item, index)
      this.couponFocus = item
      this.couponFocusIndex = index
      this.couponFocusIndex0 = index0
      this.couponFocusKey = item.code
      this.$refs.DialogCoupon.open()
    },
    async submitDialogCoupon_mixin() {
      console.log(`%c提交優惠码:`, 'color: #f00;', this.$refs.DialogCoupon.value)
      this.couponFocus.code = this.$refs.DialogCoupon.value
      if (this.couponFocusIndex0 || this.couponFocusIndex0 === 0) {
        await this.searchCoupon(this.couponFocusIndex0, this.couponFocusIndex)
      } else {
        await this.searchCoupon(this.couponFocusIndex)
      }

      this.couponFocusIndex = ''
      this.couponFocusIndex0 = ''
      this.couponFocusKey = ''
      this.$refs.DialogCoupon.close()
    },
    clearPayCoupon_mixin() {
      console.log(`%c关闭優惠码:`, 'color: #f00;', this.$refs.DialogCoupon.value)
    },
  }
}